export default "__VITE_ASSET__IBFEa1pE__"